import axios, { type AxiosInstance } from "axios";

export let versionString = "";

// IE11 cache fix
axios.defaults.headers.common["If-Modified-Since"] = 0;

const api: AxiosInstance = axios.create();

let getStudioViewAsRole: () => string | null = () => null;

export const setStudioViewAsRoleProvider = (provider: () => string | null) => {
    getStudioViewAsRole = provider;
};

api.interceptors.request.use((config) => {
    const url = config.url ?? "";
    if (url.toLowerCase().startsWith("/api/v1/studio")) {
        const role = getStudioViewAsRole();
        if (role && config.headers) {
            (config.headers as unknown as Record<string, string>)["X-Studio-View-As-Role"] = role;
        }
    }
    return config;
});

api.interceptors.response.use(
    request => {
        if (request.headers["x-login-page"]) {
            window.location.href = "/logga-in";
        }

        if (request.headers["x-version"]) {
            versionString = request.headers["x-version"];
        }

        return request;
    },
    error => {
        if (error?.request?.responseURL?.includes("sign-in?return") || error?.response?.headers["location"]?.includes("sign-in?return")) {
            const currentPath = window.location.pathname;
            const encodedPath = encodeURIComponent(currentPath);

            // will reload the entire app, should be a rare occurrence though - 
            // probably fine?
            window.location.replace("/sign-in?return=" + encodedPath);
        } else if (!window.navigator.onLine) {
            error.isOffline = true;
        }

        return Promise.reject(error);
    }
);

export default api;

export const setUserAgentExtension = (extension: string) => {
    if (!extension) {
        return;
    }

    api.defaults.headers["User-Agent-Extension"] = extension;
}
